export class GetPhotoContentsListOutputRequestModel {
  public startOrderCode: string = <string>'';                       // 使用開始受注コード
  public statusName: string = <string>'';                           // ステータス
  public classCode: string = <string>'';                            // 部門コード
  public className: string = <string>'';                            // 部門
  public pcode: string = <string>'';                                // Ｐコード
  public guideGoodsName: string = <string>'';                       // 商品案内用商品名
  public guideStandardName: string = <string>'';                    // 商品案内用規格名
  public imageFileName: string = <string>'';                        // 画像ファイル名
  public c2pfTarget: string = <string>'';                           // C2PF対象
  public imageKind: string = <string>'';                            // 画像種類
  public imageUseMethod: string = <string>'';                       // 画像使用方法
  public photographingNo: string = <string>'';                      // 撮影No
  public delivCatalogMonth: string = <string>'';                    // 月
  public delivCatalogTime: string = <string>'';                     // 回
  public packaging: string = <string>'';                            // 包材
  public plating: string = <string>'';                              // 皿盛
  public cookNecessary: string = <string>'';                        // 調理要
  public cookUnnecessary: string = <string>'';                      // 調理不要
  public explain: string = <string>'';                              // 説明素材
  public other: string = <string>'';                                // その他
  public backSide: string = <string>'';                             // 裏面
  public tempRange: string = <string>'';                            // 温度帯
  public multipleCode: string = <string>'';                         // 複数コード登録
  public pastImageInfo: string = <string>'';                        // 過去画像情報
  public imageCaution: string = <string>'';                         // 撮影注意事項
  public photoContentsName: string = <string>'';                    // 撮影指示内容
  public referenceImageNum: string = <string>'';                    // 参考資料点数
  public billingName: string = <string>'';                          // 請求先名
  public c2pfStatus: string = <string>'';                           // C2PFステータス
  public delayFlag: string = <string>'';                            // 遅延フラグ
  public supplierAnnouncement: string = <string>'';                 // 取引先への連絡事項
  public supplierInfo: string = <string>'';                         // 取引先コメント
  public statusRemandReason: string = <string>'';                   // ステータス差し戻し理由
  public remarks: string = <string>'';                              // 備考
  public photoSchedule: string = <string>'';                        // 撮影予定日
  public photographingChangeSchedule: string = <string>'';          // 変更前撮影予定日
  public carriedForward: string = <string>'';                       // 繰越
  public imageInstructDate: string = <string>'';                    // 起票日（作成指示日）
  public imageInstructUser: string = <string>'';                    // 起票者
  public buyerName: string = <string>'';                            // バイヤー名
  public c2pfUpdateDate: string = <string>'';                       // C2PF更新日時
  public peaceUpdateDate: string = <string>'';                      // PEACE更新日時
  public printDate: string = <string>'';                            // 出力日時
  public photoStudio: string = <string>'';                          // 撮影場所
  public janCode: string = <string>'';                              // JANコード
  public imageGroupNo: string = <string>'';                         // グループNo
  public smallClass: string = <string>'';                           // 小分類
  public buyerCode: string = <string>'';                            // バイヤーコード
  public billingCode: string = <string>'';                          // 請求先コード
  public sampleOrderingCode: string = <string>'';                   // サンプル発注先コード
  public sampleOrderingName: string = <string>'';                   // サンプル発注先名称
  public supplierSalesStaffName: string = <string>'';               // 取引先営業窓口担当者名
  public ebaseSpecCode: string = <string>'';                        // ｅＢＡＳＥ仕様書ＮＯ

  /**
   * コンストラクタ
   */
  public GetPhotoContentsListOutputRequestModel() { }
}